<template>
    <div id="map-container">      
    </div>
</template>
<script>
import { ApiHandler } from "@/modules/google/Singleton";
import Map from "@/modules/google/Map";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "MapComponent",
  mounted() {
    var self = this;
    new ApiHandler().load(() => {
      window.mapInstance = new Map("map-container", {
        events: {
          mapClick() {
            self.hideBarInResponsive();
          }
        },
        onStreetviewChange: state => {
          setTimeout(() => this.setIsHiddenSidebar(state), 500);
        }
      });
    });
  },
  computed: {
    ...mapGetters("interface", {
      isDimensionResponsive: "isDimensionResponsive"
    })
  },
  methods: {
    ...mapActions("interface", {
      hideSidebar: "hideSidebar",
      showSidebar: "showSidebar"
    }),
    hideBarInResponsive() {
      if (this.isDimensionResponsive) {
        this.hideSidebar();
      }
    },
    setIsHiddenSidebar(state) {
      this.$store.commit("interface/setHiddenSidebar", state);
    }
  }
};
</script>
<style lang="scss">
</style>

